
let uid = 0
export default {
  name: 'DropdownBgDecor',
  data() {
    const id = `bg-${++uid}`
    return {
      gradLeft: `${id}-left`,
      gradRight: `${id}-right`,
    }
  },
}
